// extracted by mini-css-extract-plugin
module.exports = {"tile":"DefaultAppTileButton_tile__8m5tS","buttonContent":"DefaultAppTileButton_buttonContent___4Bqh"};